<template>
    <div class="login-vue" :style="bg">
        <div class="container">
            <p class="title">集抄管理平台</p>
            <div class="input-c">
                <Input prefix="ios-contact" v-model="account" placeholder="用户名" clearable @on-blur="verifyAccount"/>
                <p class="error">{{accountError}}</p>
            </div>
            <div class="input-c">
                <Input type="password" v-model="pwd" prefix="md-lock" placeholder="密码" clearable @on-blur="verifyPwd"/>
                <p class="error">{{pwdError}}</p>
            </div>
            <Button :loading="isShowLoading" class="submit" type="primary" @keyup.enter.native="submit()" @click="submit">登录</Button>
            <!-- <p class="account"><span @click="register">注册账号</span> | <span @click="forgetPwd">忘记密码</span></p> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'login',
    data() {
        return {
            account: '',
            pwd: '',
            accountError: '',
            pwdError: '',
            isShowLoading: false,
            bg: {},
        }
    },
    created() {
        this.bg.backgroundImage = 'url(' + require('../assets/imgs/bg0' + new Date().getDay() + '.jpg') + ')'
    },
    mounted(){
        this.account = localStorage.getItem('userAccount');
        document.addEventListener('keydown', this.keyDown);
    },
    watch: {
        $route: {
            handler(route) {
                this.redirect = route.query && route.query.redirect
            },
            immediate: true,
        },
    },
    methods: {
        keyDown(e){
            var keyCode = e.keyCode;
            // Esc slide-up
            if (keyCode === 13) {
                this.submit();
            }
        },
        verifyAccount() {
            if (this.account !== 'admin') {
                // this.accountError = '账号为admin'
            } else {
                this.accountError = ''
            }
        },
        verifyPwd() {
            if (this.pwd !== 'admin') {
                // this.pwdError = '密码为admin'
            } else {
                this.pwdError = ''
            }
        },
        register() {

        },
        forgetPwd() {

        },
        submit() {

            if (this.account === '' || this.pwd === '') {
                this.$Modal.info({
                    title: "提示",
                    content: "请输入正确的用户名和密码"
                });
                return;
            }

            var that = this;
            this.isShowLoading = true;
            that.$axios.post('/api/user/login', {
                userAccount: that.account,
                userPassword: that.pwd
            }).then((res) => {
                var data = res.data?res.data:res;
                console.log(res);
                if (data.errorCode != 0) {
                    // that.$Notice.error({
                    // title: "异常",
                    // desc: data.errorInfo
                    // });
                    return;
                }

                var userObject = data.body;
                if(userObject != undefined && userObject.userId != undefined){
                    // 登录成功 设置用户信息
                    localStorage.setItem('userImg', 'https://avatars3.githubusercontent.com/u/22117876?s=460&v=4')
                    localStorage.setItem('userAccount', userObject.userAccount)
                    localStorage.setItem('userName', userObject.userName)
                    localStorage.setItem('userAuth', userObject.userAuth)
                    localStorage.setItem('userMeterType', userObject.userMeterType)
                    document.removeEventListener('keydown', that.keyDown);
                    // 登录成功 假设这里是后台返回的 token
                    localStorage.setItem('token', 'i_am_token')
                    if(userObject.userAuth == 0){
                        that.$router.push({ path: this.redirect || '/distributeaccount' })
                    }else{
                        that.$router.push({ path: this.redirect || '/' })
                    }
                    
                }

            }).catch((error) => {
                that.$Notice.error({
                    title: "异常",
                    desc: error
                });
                console.log(error);
            }).finally(() => {
                that.isShowLoading = false;
            });

            // if (this.account === 'admin' && this.pwd === 'admin') {
            //     this.isShowLoading = true
            //     // 登录成功 设置用户信息
            //     localStorage.setItem('userImg', 'https://avatars3.githubusercontent.com/u/22117876?s=460&v=4')
            //     localStorage.setItem('userName', '测试账号')
            //     // 登录成功 假设这里是后台返回的 token
            //     localStorage.setItem('token', 'i_am_token')
            //     this.$router.push({ path: this.redirect || '/' })
            //     //数据库里有一些表号是0000001800xxxx的，一共,2个，这些单独弄一个账号，名字：fjyd，密码：fjyd123
            // } else if ((this.account === 'fjyd' && this.pwd === 'fjyd123')||(this.account === 'hawiceshi' && this.pwd === 'hawi2019')) {
            //     this.isShowLoading = true
            //     // 登录成功 设置用户信息
            //     localStorage.setItem('userImg', 'https://avatars3.githubusercontent.com/u/22117876?s=460&v=4')
            //     localStorage.setItem('userName', this.account)
            //     // 登录成功 假设这里是后台返回的 token
            //     localStorage.setItem('token', 'i_am_token')
            //     this.$router.push({ path: this.redirect || '/' })
            // } else {
            //     if (this.account !== 'admin') {
            //         // this.accountError = '账号为admin'
            //     }

            //     if (this.pwd !== 'admin') {
            //         // this.pwdError = '密码为admin'
            //     }
            // }
        },
    },
}
</script>

<style>
.login-vue {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}
.login-vue .container {
    background: rgba(255, 255, 255, .5);
    width: 300px;
    text-align: center;
    border-radius: 10px;
    padding: 30px;
}
.login-vue .ivu-input {
    background-color: transparent;
    color: #fff;
    outline: #fff;
    border-color: #fff;
}
.login-vue ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: rgba(255, 255, 255, .8);
}
.login-vue :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: rgba(255, 255, 255, .8);
}
.login-vue ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: rgba(255, 255, 255, .8);
}
.login-vue :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba(255, 255, 255, .8);
}
.login-vue .title {
    font-size: 16px;
    margin-bottom: 20px;
}
.login-vue .input-c {
    margin: auto;
    width: 200px;
}
.login-vue .error {
    color: red;
    text-align: left;
    margin: 5px auto;
    font-size: 12px;
    padding-left: 30px;
    height: 20px;
}
.login-vue .submit {
    width: 200px;
}
.login-vue .account {
    margin-top: 30px;
}
.login-vue .account span {
    cursor: pointer;
}
.login-vue .ivu-icon {
    color: #eee;
}
.login-vue .ivu-icon-ios-close-circle {
    color: #777;
}
</style>
